export const UPG_TICKET_PREFIX = 'v2:';
